module.exports = __webpack_public_path__ + "static/Itello-fc547ae27a7e2fe330954354c6bb8a4b.png";